// extracted by mini-css-extract-plugin
module.exports = {"date-picker__overlay":"BasicDatePicker_date-picker__overlay__sZEyS","date-picker":"BasicDatePicker_date-picker__DUwfu"};